import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgLocation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 1.333A4.663 4.663 0 0 0 3.333 6C3.333 9.5 8 14.667 8 14.667S12.667 9.5 12.667 6A4.663 4.663 0 0 0 8 1.333zm0 6.334a1.667 1.667 0 1 1 .001-3.335A1.667 1.667 0 0 1 8 7.667z",
		fillRule: "nonzero"
	})
});
export default SvgLocation;
